import { t } from 'services/translation';

export const buildLabel = (count, unitType) => {
  const noun = count > 1 ? t(unitType.noun_plural) : t(unitType.noun_singular);

  return `${count} ${noun}`;
};

export const getUnitCounts = (guests) => {
  const unitCounts = {};
  for (let i = 0; i < guests?.length; i++) {
    if (!unitCounts[guests[i].unitType]) {
      unitCounts[guests[i].unitType] = 1;
    } else {
      unitCounts[guests[i].unitType]++;
    }
  }
  return unitCounts;
};

export const getCountObject = (
  initialTicketQuantity,
  valuesWithPositiveCount
) => {
  if (!initialTicketQuantity) {
    return valuesWithPositiveCount[0];
  }

  if (initialTicketQuantity === 1) {
    return valuesWithPositiveCount[0];
  }

  let countObject = valuesWithPositiveCount.find(
    (obj) => obj.count !== initialTicketQuantity
  );

  if (!countObject && initialTicketQuantity !== 1) {
    countObject = {
      id: valuesWithPositiveCount[0].id,
      count: initialTicketQuantity,
    };
  }

  return countObject || {};
};

export const buildCollapsedLabel = (
  unitTypes,
  unitValues,
  initialTicketQuantity = null
) => {
  const valuesWithPositiveCount = unitValues.filter((val) => val.count > 0);
  if (valuesWithPositiveCount.length > 1) {
    // Use root unit type
    const totalCount = valuesWithPositiveCount.reduce(
      (total, val) => total + val.count,
      0
    );
    return buildLabel(totalCount, unitTypes.root);
  }

  if (valuesWithPositiveCount.length === 1) {
    const val = getCountObject(initialTicketQuantity, valuesWithPositiveCount);
    let unitType = unitTypes.items.find((u) => u.id === val.id);
    if (!unitType) {
      unitType = unitTypes.items[0];
    }
    return buildLabel(val.count, unitType);
  }
  const count =
    initialTicketQuantity !== null && initialTicketQuantity !== 1
      ? initialTicketQuantity
      : 1;
  return buildLabel(count, unitTypes.root);
};

export const buildEditBookingLabel = (unitTypes, guestList) => {
  const unitCounts = getUnitCounts(guestList);
  const valuesWithPositiveCount = Object.keys(unitCounts).length;

  if (valuesWithPositiveCount > 1) {
    // Use root unit type
    const totalCount = guestList && guestList.length;
    return buildLabel(totalCount, unitTypes.root);
  }

  // If all unit types are the same
  if (valuesWithPositiveCount === 1) {
    let unitType = unitTypes.items.find(
      (unit) => unit.id === guestList[0].unitType
    );
    if (!unitType) {
      unitType = unitTypes.items[0];
    }
    return buildLabel(guestList.length, unitType);
  }
  return buildLabel(1, unitTypes.root);
};
